import styled from 'styled-components';

export const TaulaResultatsContainer = styled.div`
  margin-left: 18%;
  margin-right: 18%;

  @media screen and (max-height: 400px) {
    margin: 0 5% 0 5%;
  }

  @media screen and (max-width: 768px) {
    margin-left: 5%;
    margin-right: 5%;
  }

  @media screen and (max-width: 464px) {
    margin-left: 5%;
    margin-right: 5%;
  }
`;

export const TaulaCapes = styled.div`
  display: flex;
  flex-direction: column;
`;

export const NoResults = styled.h4`
  display: flex;
  justify-content: center;
`;
